module.exports = __webpack_public_path__ + "img/badge_gray_adv-supports.55d81904.svg";